import { MimeType_csv, MimeType_html, Module } from '@nu-art/ts-common';
import { ModuleFE_XHR } from '@nu-art/thunderstorm-frontend/index';
import { HeaderKey_ContentType } from '@nu-art/thunderstorm-shared';
import { ApiDef_PathwayImport } from '@app/data-migration-shared';
/**
 * Calls the pathway-import endpoints sending the raw CSV File as `text/csv`.
 * Both endpoints take a `void` JSON body, so the File travels as the raw request body
 * (the backend reads the stream directly) — hence ModuleFE_XHR, not `apiWithBody`.
 */
class ModuleFE_PathwayImport_Class extends Module {
    /** Dry-run: returns the structural counts + any validation errors (HTTP 200, errors in the body). */
    validatePathway = (file) => this.csvRequest(ApiDef_PathwayImport._v1.validatePathway, file).executeSync();
    /** Commit: returns ImportResult (has `pathwayId`) on success, or ImportSummary with errors if it still fails validation. */
    importPathway = (file) => this.csvRequest(ApiDef_PathwayImport._v1.importPathway, file).executeSync();
    /**
     * Attaches the optional HTML to a just-imported pathway. The HTML travels as the raw text/html body
     * (like the CSV, hence ModuleFE_XHR) and the pathwayId as a query param. Resolves to the persisted
     * download URL; on failure the backend rolls the whole import back and this rejects.
     */
    attachHtml = (pathwayId, file) => ModuleFE_XHR.createRequest(ApiDef_PathwayImport._v1.attachHtml)
        .setUrlParams({ pathwayId })
        .setTimeout(ApiDef_PathwayImport._v1.attachHtml.timeout)
        .setHeader(HeaderKey_ContentType, MimeType_html)
        .setBody(file, false)
        .executeSync();
    csvRequest = (apiDef, file) => ModuleFE_XHR.createRequest(apiDef)
        .setTimeout(apiDef.timeout)
        .setHeader(HeaderKey_ContentType, MimeType_csv)
        .setBody(file, false);
}
export const ModuleFE_PathwayImport = new ModuleFE_PathwayImport_Class();
//# sourceMappingURL=ModuleFE_PathwayImport.js.map